import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import UserSignIn from './UserSignIn';
import UserLostPwd from './UserLostPwd';
import UserSignUp from './UserSignUp';
import UserPwd from './UserPwd';
import API from '../../api';
import './user-signin-modal.css';
import { debug } from './../../utils';
function UserSignInModal({ show, onSuccess = null, onClose = null, onAbort = null, options = null }) {
  const iframeRef = useRef(null);
  const defaultTab = 'signIn';
  const user = useSelector((state) => state.user);
  const [tab, setTab] = useState(defaultTab);
  const [optionsCopy, setOptionsCopy] = useState(options);
  useEffect(() => {
    setOptionsCopy(options);
  }, [options])
  useEffect(() => {
    setTab(defaultTab);
  }, [show]);
  useEffect(() => {
    if (user.isSignedIn) {
      if (typeof onSuccess === "function") {
        onSuccess(user);
        return;
      }
      if (typeof optionsCopy?.onSuccess === "function") {
        optionsCopy.onSuccess(user);
        return;
      }
    }
  }, [user, onSuccess, optionsCopy]);
  const abort = () => {
    if (typeof onAbort === "function") {
      onAbort();
      return;
    }
    if (typeof optionsCopy?.onAbort === "function") {
      optionsCopy.onAbort();
      return;
    }
    if (typeof onClose === "function") {
      onClose();
      return;
    }
  };
  const handleOnClose = () => {
    if (tab !== defaultTab) {
      setTab(defaultTab);
      return;
    }
    if (typeof optionsCopy?.onClose === "function") {
      optionsCopy.onClose();
    } else if (onClose) {
      onClose();
    }
  };
  const handleOnTabSwitch = (newTab) => {
    if (newTab != 'close') {
      setTab(newTab != '' ? newTab : defaultTab);
    } else {
      setTab(defaultTab);
      handleOnClose();
    }
  }
  return (
    <Modal show={show} onHide={abort} className='userSignInModal'>
      <Modal.Header closeButton className="text-center">
        <div className='modal-title' style={{ height: '25px' }}>
        </div>
      </Modal.Header>
      <Modal.Body>
        {tab === 'signIn' && <UserSignIn onTabSwitch={handleOnTabSwitch} options={optionsCopy} />}
        {(optionsCopy?.userType && tab === 'signUp') && <UserSignUp onTabSwitch={handleOnTabSwitch} options={optionsCopy} />}
        {tab === 'lostPwd' && <UserLostPwd onTabSwitch={handleOnTabSwitch} options={optionsCopy} updateOptions={payload => setOptionsCopy({ ...optionsCopy, ...payload })} />}
        {tab === 'newPwd' && <UserPwd onTabSwitch={handleOnTabSwitch} options={optionsCopy} updateOptions={payload => setOptionsCopy({ ...optionsCopy, ...payload })} onSuccess={onSuccess} />}
      </Modal.Body>
    </Modal>
  );
}
export default UserSignInModal;
